import { render, staticRenderFns } from "./PuzzleSelector.vue?vue&type=template&id=d12c1dba&scoped=true&"
import script from "./PuzzleSelector.vue?vue&type=script&lang=ts&"
export * from "./PuzzleSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PuzzleSelector.vue?vue&type=style&index=0&id=d12c1dba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12c1dba",
  null
  
)

export default component.exports